import { useState, useEffect, memo } from "react";
import { toast } from "react-toastify";
import userStore from "../../store/userStore";
import ModalExtraSmall from "../ModalExtraSmall";
import axios from "axios";
import { useRouter } from "next/navigation";
import { bloquerMembre } from "../../tools/bloquerMembre";
import { ImArrowUp, ImArrowDown } from "react-icons/im";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  Md18UpRating,
  MdBlock,
  MdDelete,
  MdEdit,
  MdFlag,
  MdOutlineMoreHoriz,
  MdReport,
  MdShare,
  MdStar,
  MdStarBorder,
  MdTag,
} from "react-icons/md";

function ItemFooterCommentaires({
  children,
  passShowFormReponse,
  passShowFormEdit,
  ...props
}) {
  const userPermalink = userStore.getState().userPermalink;
  const router = useRouter();
  const [showModalOptions, setShowModalOptions] = useState(false);

  const [points, setPoints] = useState(props.item.points);
  var valeurVotePositifFromApi = false;
  if (
    props.item.voted &&
    props.item.voted &&
    props.item.voted_type == "positif"
  )
    valeurVotePositifFromApi = true;

  var valeurVoteNegatifFromApi = false;
  if (
    props.item.voted &&
    props.item.voted &&
    props.item.voted_type == "negatif"
  )
    valeurVoteNegatifFromApi = true;

  const [valeurVotePositif, setValeurVotePositif] = useState(
    valeurVotePositifFromApi
  );
  const [valeurVoteNegatif, setValeurVoteNegatif] = useState(
    valeurVoteNegatifFromApi
  );

  const voter = async (valeur, permalink) => {
    if (!props.userTk) {
      // toast("Connectez vous pour voter.", { type: "error" });
      router.push("/m/connexion");
      return false;
    }

    // on met l'effet tout de suite
    if (valeur == "positif" && valeurVotePositif == false) {
      setValeurVotePositif(true);
      setValeurVoteNegatif(false);
      setPoints("..");
    } else if (valeur == "negatif" && valeurVoteNegatif == false) {
      setValeurVotePositif(false);
      setValeurVoteNegatif(true);
      setPoints("..");
    } else {
      setValeurVotePositif(false);
      setValeurVoteNegatif(false);
      setPoints("..");
    }

    var bodyFormData = new URLSearchParams();
    bodyFormData.append("valeur", valeur);
    bodyFormData.append("permalink", props.item.id);
    bodyFormData.append("token", props.userTk);

    await fetch(process.env.NEXT_PUBLIC_API_URL + "/api/commentaires/voter", {
      method: "POST",
      body: bodyFormData,
      // headers: {
      //   "User-Agent": "Choualbox Next",
      // },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((result) => {
        if (result.status == 200) {
          setPoints(result.newpoints);
          if (result.type == "voted" && valeur == "positif") {
            setValeurVotePositif(true);
            setValeurVoteNegatif(false);
          } else if (result.type == "voted" && valeur == "negatif") {
            setValeurVoteNegatif(true);
            setValeurVotePositif(false);
          } else {
            setValeurVotePositif(false);
            setValeurVoteNegatif(false);
          }
        } else {
          toast(result.message, { type: "error" });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [saved, setSaved] = useState(props.item.saved);
  const [saveInProcess, setSaveInProcess] = useState(false);

  const favoris = async () => {
    if (!props.userTk) {
      toast("Vous devez être membre pour ajouter un favoris.", {
        type: "error",
      });
      return false;
    }

    // setSaved(!saved);
    setSaveInProcess(true);

    var bodyFormData = new URLSearchParams();
    bodyFormData.append("id_module", props.item.id);
    bodyFormData.append("token", props.userTk);
    bodyFormData.append("module", props.module);

    await fetch(
      process.env.NEXT_PUBLIC_API_URL + "/api/membres/ajouterfavoris",
      {
        method: "POST",
        body: bodyFormData,
        // headers: {
        //   "User-Agent": "Choualbox Next",
        // },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((result) => {
        if (result.status == 200) {
          setSaved(result.saved);
        }

        toast(result.message);
        setSaveInProcess(false);
      });

    setSaveInProcess(false);
  };

  function marquerNSFW() {
    if (confirm("Marquer ce commentaire NSFW?") == true) {
      var bodyFormData = new URLSearchParams();
      bodyFormData.append("token", props.userTk);
      bodyFormData.append("id", props.item.id);

      const options = {
        headers: {
          // "User-Agent": "Choualbox Next",
        },
      };
      axios
        .post(
          process.env.NEXT_PUBLIC_API_URL + "/api/commentaires/ajouternsfw",
          bodyFormData,
          options
        )
        .then((response) => {
          if (response.data.status === 200) {
            toast(response.data.message, { type: "success" });
            // router.reload(window.location.pathname);
            router.refresh();
          } else {
            toast(response.data.message, { type: "error" });
          }
        });
    }
  }

  function supprimer() {
    if (confirm("Supprimer ce commentaire ?") == true) {
      var bodyFormData = new URLSearchParams();
      bodyFormData.append("token", props.userTk);
      bodyFormData.append("id", props.item.id);

      const options = {
        headers: {
          // "User-Agent": "Choualbox Next",
        },
      };
      axios
        .post(
          process.env.NEXT_PUBLIC_API_URL + "/api/commentaires/desactiver",
          bodyFormData,
          options
        )
        .then((response) => {
          if (response.data.status === 200) {
            toast(response.data.message, { type: "success" });
            // router.reload(window.location.pathname);
            router.refresh();
          } else {
            toast(response.data.message, { type: "error" });
          }
        });
    }
  }

  function moderer() {
    if (confirm("Modérer ce commentaire ?") == true) {
      var bodyFormData = new URLSearchParams();
      bodyFormData.append("token", props.userTk);
      bodyFormData.append("id", props.item.id);

      const options = {
        headers: {
          // "User-Agent": "Choualbox Next",
        },
      };
      axios
        .post(
          process.env.NEXT_PUBLIC_API_URL + "/api/commentaires/moderer",
          bodyFormData,
          options
        )
        .then((response) => {
          if (response.data.status === 200) {
            toast(response.data.message, { type: "success" });
            // router.reload(window.location.pathname);
            router.refresh();
          } else {
            toast(response.data.message, { type: "error" });
          }
        });
    }
  }

  // share / partager
  const [shareIsSupported, setShareIsSupported] = useState(false);

  useEffect(() => {
    if (navigator.share) {
      setShareIsSupported(true);
    }
  }, []);

  const handleShare = async () => {
    try {
      await navigator.share({
        text: props.item.texte,
        url:
          typeof window !== "undefined"
            ? window.location.href + "#comid" + props.item.id
            : null,
        title: "Partager",
      });
    } catch (err) {
      console.log("Sharing canceled:", err);
    }
  };

  return (
    <>
      <div className="flex sm:gap-x-2 relative justify-between w-full mt-0 pb-0">
        <div className="flex">
          <button
            onClick={(e) => {
              props.userTk
                ? passShowFormReponse(true)
                : toast.info("Connectez-vous pour commenter.");
            }}
            className="flex h-8 items-center justify-center outline-none text-base-content/70 hover:text-base-content/100 hover:bg-base-200 cursor-pointer"
            aria-label="Répondre"
          >
            {/* <div className="sm:hidden">
              <MdReply className="w-4 h-4" />
            </div> */}
            <div className="text-sm">
              <div className="sm:inline-block text-sm font-semibold">
                Répondre
              </div>
              {/* <div className="inline-block sm:hidden text-xs">répondre</div> */}
            </div>
          </button>
        </div>
        <div
          className="group flex"
          onClick={(e) => {
            e.stopPropagation();
            voter("positif", props.item.permalink);
          }}
        >
          <button
            className={`flex w-16 h-8 px-2 items-center justify-center outline-none group-hover:bg-base-200 rounded-sm cursor-pointer ${
              valeurVotePositif
                ? "text-success"
                : "text-base-content/70 hover:text-base-content/100"
            }
          `}
            aria-label="Vote positif"
          >
            <div className="w-12">
              {valeurVotePositif ? (
                <ImArrowUp className="w-4 h-4" />
              ) : (
                // <svg className="w-4 h-4" viewBox="0 0 24 24">
                //   <path
                //     fill="currentColor"
                //     d="M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z"
                //   />
                // </svg>
                <ImArrowUp className="w-4 h-4" />
                // <svg className="w-4 h-4" viewBox="0 0 24 24">
                //   <path
                //     fill="currentColor"
                //     d="M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
                //   />
                // </svg>
              )}
            </div>
            <div
              className={`flex sm:w-12 w-6 items-center justify-center outline-none text-sm ${
                valeurVotePositif
                  ? "text-success"
                  : "text-base-content/70 hover:text-base-content/100"
              }`}
            >
              {points}
            </div>
          </button>
        </div>
        <button
          className={`flex w-12 h-8 px-2 items-center justify-center outline-none hover:bg-base-200 rounded-sm cursor-pointer ${
            valeurVoteNegatif
              ? "text-error"
              : "text-base-content/70 hover:text-base-content/100"
          }
          `}
          onClick={(e) => {
            e.stopPropagation();
            voter("negatif", props.item.permalink);
          }}
          aria-label="Vote négatif"
        >
          <div className="w-12 flex items-center justify-center">
            {valeurVoteNegatif ? (
              <ImArrowDown className="w-4 h-4" />
            ) : (
              // <svg className="w-4 h-4" viewBox="0 0 24 24">
              //   <path
              //     fill="currentColor"
              //     d="M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z"
              //   />
              // </svg>
              <ImArrowDown className="w-4 h-4" />
              // <svg className="w-4 h-4" viewBox="0 0 24 24">
              //   <path
              //     fill="currentColor"
              //     d="M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
              //   />
              // </svg>
            )}
          </div>
        </button>
        <div className="relative">
          <button
            onClick={(e) => {
              setShowModalOptions(true);
              e.stopPropagation();
            }}
            className="flex w-12 h-8 items-center justify-center outline-none text-base-content/70 hover:text-base-content/100 hover:bg-base-200 cursor-pointer"
            aria-label="Options"
          >
            <MdOutlineMoreHoriz className="w-4 h-4" />
          </button>
          {showModalOptions && (
            <ModalExtraSmall
              isOpen={showModalOptions}
              handleChange={() => {
                // router.push(returnHref, undefined, {
                //   shallow: true,
                //   scroll: false,
                // });
                // var uri = window.location.toString();
                // var clean_uri = uri.substring(0, uri.indexOf("#"));
                // router.replace(clean_uri);
                setShowModalOptions(false);
              }}
            >
              {props.userTk && props.item.can_edit == 1 ? (
                <button
                  className="flex w-full items-center text-base-content leading-12 hover:text-secondary text-sm cursor-pointer"
                  onClick={(e) => {
                    passShowFormEdit(true);
                    setShowModalOptions(false);
                    e.stopPropagation();
                  }}
                >
                  <MdEdit className="w-4 h-4 mr-2" /> Modifier
                </button>
              ) : null}
              {props.userTk && (
                <button
                  onClick={(e) => {
                    favoris();
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                  className={`flex w-full items-center text-base-content leading-12 hover:text-secondary text-sm cursor-pointer
                     ${
                       saved == 1 ? "text-favoris" : "text-base-content-dark"
                     } ${saveInProcess && "opacity-50"}
                     `}
                >
                  {saved ? (
                    <>
                      <MdStar className="w-6 h-6 mr-1" />
                      Retirer des Favoris
                    </>
                  ) : (
                    <>
                      <MdStarBorder className="w-6 h-6 mr-1" /> Ajouter aux
                      Favoris
                    </>
                  )}
                </button>
              )}
              <button
                onClick={(e) =>
                  shareIsSupported
                    ? handleShare()
                    : alert(
                        "La fonction partager n'est pas disponible sur ce navigateur."
                      )
                }
                className="flex w-full items-center text-base-content leading-12 hover:text-secondary text-sm cursor-pointer"
              >
                <MdShare className="w-4 h-4 mr-2" /> Partager ce commentaire
              </button>
              {props.item.can_delete === 1 && (
                <button
                  className="flex w-full items-center text-base-content leading-12 hover:text-secondary text-sm cursor-pointer"
                  onClick={(e) => {
                    supprimer();
                    e.stopPropagation();
                  }}
                >
                  <MdDelete className="w-4 h-4 mr-2" /> Supprimer
                </button>
              )}
              {props.item.can_moderate === 1 ? (
                <button
                  className="flex w-full items-center text-base-content leading-12 hover:text-secondary text-sm cursor-pointer"
                  onClick={(e) => {
                    moderer();
                    e.stopPropagation();
                  }}
                >
                  <MdFlag className="w-4 h-4 mr-2" /> Modérer
                </button>
              ) : null}
              {props.item.can_moderate === 1 && props.item.nsfw == 0 ? (
                <button
                  className="flex w-full items-center text-base-content leading-12 hover:text-secondary text-sm cursor-pointer"
                  onClick={(e) => {
                    marquerNSFW();
                    e.stopPropagation();
                  }}
                >
                  <Md18UpRating className="w-4 h-4 mr-2" /> Marquer NSFW
                </button>
              ) : null}
              <button
                className="flex w-full items-center text-base-content leading-12 hover:text-secondary text-sm cursor-pointer"
                onClick={(e) => {
                  router.push(
                    "/signaler?module=commentaire&id_module=" + props.item.id
                  );
                  e.stopPropagation();
                }}
              >
                <MdReport className="w-4 h-4 mr-2" /> Signaler ce commentaire
              </button>
              {props.userTk && userPermalink != props.item.membre_permalink ? (
                <>
                  <div className="border-t border-base-content/10 my-2"></div>
                  <button
                    className="flex w-full items-center text-base-content leading-12 hover:text-secondary text-sm cursor-pointer"
                    onClick={(e) => {
                      if (
                        confirm(
                          "Bloquer " +
                            props.item.membre_pseudo +
                            " ? " +
                            props.item.membre_pseudo +
                            " ne pourra plus voir votre profil, vos boxs, vos commentaires ou vous contacter et vice versa."
                        ) == true
                      ) {
                        bloquerMembre(props.item.membre_pseudo, props.userTk);
                      }

                      e.stopPropagation();
                    }}
                  >
                    <MdBlock className="w-4 h-4 mr-2" /> Bloquer{" "}
                    {props.item.membre_pseudo}
                  </button>
                  <button
                    className="flex w-full items-center text-base-content leading-12 hover:text-secondary text-sm cursor-pointer"
                    onClick={(e) => {
                      router.push(
                        "/signaler?module=membre&id_module=" +
                          props.item.membre_permalink
                      );
                      e.stopPropagation();
                    }}
                  >
                    <MdReport className="w-4 h-4 mr-2" /> Signaler{" "}
                    {props.item.membre_pseudo}
                  </button>
                </>
              ) : null}
            </ModalExtraSmall>
          )}
        </div>
        <div className="hidden sm:block sm:grow"></div>
      </div>
    </>
  );
}

export default memo(ItemFooterCommentaires);
